//
//
//
//
//
//
//
//
//
//
//
//

var SERVERAPI = process.env.VUE_APP_OKEY_SERVER_API;
export default {
  name: "Translation",
  data: function data() {
    return {
      translationInfo: "",
      translationInfoLanguage: "",
      translationInfoShow: false,
      translationBoxBbtn: false,
      translationIng: false
    };
  },
  props: {
    info: {
      type: String,
      default: ""
    }
  },
  watch: {
    info: function info(newVal, oldVal) {
      if (newVal) {
        this.translationInfo = "", this.translationInfoLanguage = "";
        this.translationInfoShow = false;
        this.translationBoxBbtn = false;
      }
    }
  },
  created: function created() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.info) {
        _this.translationBoxBbtn = true;
      }
    });
  },
  methods: {
    clickTranslation: function clickTranslation() {
      var _this2 = this;
      if (this.info) {
        if (!this.translationInfoShow) {
          if (this.translationInfoLanguage != this.$i18n.locale) {
            this.translationInfo = "";
            this.translationInfoLanguage = "";
            this.translationIng = true;
            if (!this.translationInfo) {
              this.$http({
                url: SERVERAPI + "/translateAi/translate",
                method: 'post',
                data: {
                  text: this.info,
                  language: this.$i18n.locale
                }
              }).then(function (data) {
                console.log("data", data);
                if (data && data.code === 200) {
                  _this2.translationInfo = data.data;
                  _this2.translationInfoLanguage = _this2.$i18n.locale;
                  _this2.translationInfoShow = true;
                }
                _this2.translationIng = false;
              }).catch(function () {
                _this2.translationIng = false;
              });
            }
          } else {
            this.translationInfoShow = true;
          }
        } else {
          this.translationInfoShow = false;
        }
      }
    }
  }
};